import axios from "axios";

const axiosConfig = axios.create({
  baseURL: "https://api.bookybook.rs/",
  withCredentials: true,
});

export default axiosConfig;
